"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Icon = _interopRequireDefault(require("../../atoms/Icon/Icon"));

var _theme = _interopRequireDefault(require("../../../theme/theme.styles"));

var _InputFile = require("./InputFile.styles");

var _excluded = ["text", "multiple", "size", "dataTestId", "action"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var InputFile = function InputFile(_ref) {
  var _ref$text = _ref.text,
      text = _ref$text === void 0 ? 'Adjuntar archivo' : _ref$text,
      _ref$multiple = _ref.multiple,
      multiple = _ref$multiple === void 0 ? false : _ref$multiple,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      _ref$dataTestId = _ref.dataTestId,
      dataTestId = _ref$dataTestId === void 0 ? 'occ-input-file' : _ref$dataTestId,
      action = _ref.action,
      props = _objectWithoutProperties(_ref, _excluded);

  var handleChange = function handleChange(value) {
    if (typeof action === 'function') action(value);
  };

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_theme["default"], null), /*#__PURE__*/_react["default"].createElement(_InputFile.Occ_InputFileContainer, {
    "data-test-id": dataTestId,
    isize: size
  }, /*#__PURE__*/_react["default"].createElement(_InputFile.Occ_InputFileLabel, {
    isize: size
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    name: "upload"
  }), text, multiple ? /*#__PURE__*/_react["default"].createElement(_InputFile.Occ_InputFile, {
    type: "file",
    onChange: handleChange,
    multiple: true,
    name: props.name
  }) : /*#__PURE__*/_react["default"].createElement(_InputFile.Occ_InputFile, {
    name: props.name,
    type: "file",
    onChange: handleChange
  }))));
};

var _default = InputFile;
exports["default"] = _default;